import { Controller } from '@hotwired/stimulus';

// Retour d'une fiche vers sa liste : l'adresse mémorisée par
// list-memory pour le chemin de la liste, sinon la liste nue.
export default class extends Controller {
    static values = { list: String };

    connect() {
        try {
            const stored = sessionStorage.getItem(`list:${this.listValue}`);
            if (stored && new URL(stored, window.location.href).origin === window.location.origin) this.element.href = stored;
        } catch {
            // Stockage indisponible : lien vers la liste nue.
        }
    }
}
